export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/App.worker.41055cb3.js");
}
